import { render, staticRenderFns } from "./ByDate.vue?vue&type=template&id=2c6c0b04&scoped=true&"
import script from "./ByDate.vue?vue&type=script&lang=js&"
export * from "./ByDate.vue?vue&type=script&lang=js&"
import style0 from "./ByDate.vue?vue&type=style&index=0&id=2c6c0b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c0b04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
